import React, { FC, ReactElement } from "react";
import styled from "styled-components";
import Modal from "react-responsive-modal";

interface Props {
  children: ReactElement[];
  open: boolean;
  setOpen: (bool: boolean) => void;
}
const AsideModal: FC<Props> = ({ children, open, setOpen }) => {
  return (
    <Row>
      <Main>{children[0]}</Main>
      {open ? null : <Aside>{children[1]}</Aside>}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        classNames={{
          modal: "custom-modal",
          overlay: "custom-overlay",
          closeButton: "custom-close",
        }}
        focusTrapped={false}
      >
        {open ? children[1] : null}
      </Modal>
    </Row>
  );
};

const Row = styled.div`
  display: flex;
`;

const Main = styled.div`
  flex-grow: 1;
  max-width: 100%;
`;

const Aside = styled.div`
  flex-shrink: 0;
  flex-basis: 380px;
  margin-left: 50px;
  @media (max-width: 1300px) {
    display: none;
  }
`;

export default AsideModal;
